import { useMemo } from "react";

import { useSelector } from "react-redux";

import { EMPTY_GROUPED_TECHNOLOGIES } from "app/pages/sales-intelligence/domain/technology/constants/model";
import useGroupedTechnologiesQuery from "app/pages/sales-intelligence/modules/technology/queries/useGroupedTechnologiesQuery";
import settingsService from "app/pages/sales-intelligence/sub-modules/advanced-search/services/sw-settings/settingsService";
import {
    selectIntentSignalCountriesDetails,
    selectIntentSignalSelectedTopics,
} from "app/pages/sales-intelligence/sub-modules/intent/store/signal/selectors/selectors";
import { NEWS_CATEGORIES_BY_TYPE } from "app/pages/sales-intelligence/sub-modules/signals/utils/news/const";

import { selectSignalsDescription, selectSignalsSource } from "../../../sub-modules/signals/store/selectors";
import createSignalFiltersViewResolver from "../services/signals-filters-view-resolver/factory";

export default function useSignalFiltersViewResolver() {
    const signalsDescription = useSelector(selectSignalsDescription);
    const intentSelectedTopics = useSelector(selectIntentSignalSelectedTopics);
    const intentUserCountries = useSelector(selectIntentSignalCountriesDetails);
    const signalSource = useSelector(selectSignalsSource);

    const { data: signalTechnologies = EMPTY_GROUPED_TECHNOLOGIES } = useGroupedTechnologiesQuery();

    return useMemo(() => {
        return createSignalFiltersViewResolver({
            adNetworks: signalsDescription?.adNetworks ?? [],
            countries: settingsService.getCurrentComponentCountries(),
            technologies: signalTechnologies,
            newsCategories: NEWS_CATEGORIES_BY_TYPE,
            intentSelectedTopics: intentSelectedTopics ?? [],
            intentUserCountries: intentUserCountries ?? [],
            signalSource,
        });
    }, [signalsDescription?.adNetworks, signalTechnologies, intentSelectedTopics, intentUserCountries, signalSource]);
}
